import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';


const KEY_ACTION = ActionType.IsSsoRequest;
const ACTIONS = [
  ActionType.IsSsoRequest,
  ActionType.IsSsoResponse,
  ActionType.IsSsoError,
];


type Payload = boolean;


type Meta = {
  email: string;
};


/**
 * Dispatch this action to authenticate to the portal through Saml SSO 
 */
export const isSsoAction = () => makeApiAction<Payload, Meta>({
  method: 'GET',
  endpoint: Endpoints.IsSso,
  headers: { 'content-type': 'application/json' },
  body: null,
  types: makeRsaaTypes<Payload, Meta>(ACTIONS),
  bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'ssoRedirect'], payload, successState);
};

export const isSsoReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);